import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValuesGameCoreService } from '../master-game-core/values-game-core';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ValuesGameCoreService],
})
export class ValuesGameCoreModule {}
